import type { TokenData } from "./types/chat.types";
import { CHATBOT_SESSION_ID_KEY } from "./utils/constants";

export const getLongLivedTokenObject = async (): Promise<TokenData> => {
  const LONG_LIVED_TOKEN = import.meta.env.VITE_LONG_LIVED_TOKEN || "";
  if (!LONG_LIVED_TOKEN) {
    console.log("Long lived token expected but not provided");
  }
  const tokenData: TokenData = {
    publicAccessToken: LONG_LIVED_TOKEN,
    tokenExpires: "",
    isAnonymous: true,
    scopes: [],
  };
  return tokenData;
};

export const getSessionIdCookie = (): string => {
  const cookiesString = document.cookie;
  const cookiesArray = cookiesString.split(";");

  for (const cookie of cookiesArray) {
    const trimmedCookie = cookie.trim();
    if (trimmedCookie.startsWith(`${CHATBOT_SESSION_ID_KEY}=`)) {
      return trimmedCookie.substring(`${CHATBOT_SESSION_ID_KEY}=`.length);
    }
  }

  return "";
};

export const setSessionIdCookie = (sessionId: string, maxAgeMinutes: number): string => {
  const maxAge = maxAgeMinutes * 60;

  const cookieString = `${CHATBOT_SESSION_ID_KEY}=${sessionId}; Path=/; Secure; SameSite=None; Max-Age=${maxAge}`;

  document.cookie = cookieString;

  return cookieString;
};

export const removeSessionIdCookie = (): void => {
  document.cookie = `${CHATBOT_SESSION_ID_KEY}=; Path=/; Secure; SameSite=None ; Max-Age=0`;
};